<template>
  <nav class="navbar page-container">
    <search></search>
  </nav>
</template>
<script>
import Search from './search/index.vue';

export default {
  name: 'PageNavbar',
  components: {
    Search,
  }
}
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/page-navbar/index.vue